import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FacebookIcon, InstagramIcon } from './icons/SocialIcons';

export function Footer() {
  return (
    <footer className="footer">
      <div className="shell footer-main">
        <Link to="/" className="brand footer-brand">
          <img src={`${import.meta.env.BASE_URL}assets/images/traianologo.png`} alt="Traiano 55789 — Deputado Estadual" />
        </Link>
        <div className="footer-intro">
          <p className="independent-notice">Página independente criada e mantida por apoiador. Não é canal oficial da candidatura.</p>
          <nav id="redes-sociais" className="footer-social" aria-label="Redes sociais">
            <a href="https://www.facebook.com/traianooficial/" target="_blank" rel="noreferrer" aria-label="Traiano no Facebook">
              <FacebookIcon />
              <span>Facebook</span>
            </a>
            <a href="https://www.instagram.com/ademartraiano/" target="_blank" rel="noreferrer" aria-label="Ademar Traiano no Instagram">
              <InstagramIcon />
              <span>Instagram</span>
            </a>
          </nav>
        </div>
        <img className="footer-party" src={`${import.meta.env.BASE_URL}assets/images/opcao5psd.png`} alt="PSD 55 — Partido Social Democrático" />
        <a href="#top" className="inline-flex items-center gap-2">Voltar ao topo <ArrowUpRight size={16} /></a>
      </div>
      <nav className="shell footer-links" aria-label="Navegação do rodapé">
        <Link to="/">Início</Link><Link to="/traiano">Sobre</Link><Link to="/investimentos">Projetos</Link><Link to="/avatar">Crie seu avatar e cards</Link><Link to="/galeria">Galeria</Link>
      </nav>
      <div className="shell footer-legal">
        <p>CNPJ constante no material: 68.519.191/0001-36 · PSD · PROPAGANDA ELEITORAL</p>
      </div>
    </footer>
  );
}
